module.exports = __webpack_public_path__ + "static/emi-c783c667e188c25822a8d07a67d3b617.png";